import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Switch } from '@headlessui/react'
import Cookies from 'js-cookie'

interface CookieBannerProps {
  isOpen?: boolean
  onClose?: () => void
}

const CookieBanner: React.FC<CookieBannerProps> = ({ isOpen, onClose }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [analyticsConsent, setAnalyticsConsent] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (isOpen !== undefined) {
      setIsVisible(isOpen)
    } else {
      setIsVisible(true)
    }

    const sgAnalyticsCookies = Cookies.get('sg_analytics_cookies')
    setAnalyticsConsent(sgAnalyticsCookies === 'true')
  }, [isOpen])

  const handleClose = () => {
    setIsVisible(false)
    if (onClose) onClose()
  }

  const handleAccept = () => {
    if (analyticsConsent) {
      Cookies.set('sg_analytics_cookies', 'true', { expires: 365 })
    } else {
      Cookies.set('sg_analytics_cookies', 'false', { expires: 365 })
    }
    handleClose()
  }

  const handleAnalyticsToggle = (checked: boolean) => {
    setAnalyticsConsent(checked)
  }

  if (!isVisible) {
    return null
  }

  return (
    <div className='fixed bottom-0 left-0 right-0 bg-redpink text-white p-4 flex flex-col md:flex-row justify-end items-center z-50'>
      <div className='flex gap-2 ml-4 items-center'>
        <span className='ml-2'>{t('analyticsConsent')}</span>
        <Switch
          checked={analyticsConsent}
          onChange={handleAnalyticsToggle}
          className={`${
            analyticsConsent ? 'bg-anthracite' : 'bg-gray-500'
          } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-anthracite focus:ring-offset-2`}
        >
          <span
            className={`${
              analyticsConsent ? 'translate-x-6' : 'translate-x-1'
            } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
          />
        </Switch>
      </div>
      <button
        onClick={handleAccept}
        className='bg-anthracite hover:bg-anthraciteLight text-white px-4 py-2 rounded transition-colors mt-4 md:mt-0 md:ml-4'
      >
        {t('confirm')}
      </button>
    </div>
  )
}

export default CookieBanner
